<template>
  <div class="home">
    <div class="container">
      <div class="columns is-centered">
        <div class="column">
          <div class="columns">
            <ValidationObserver v-slot="{ errors }" tag="div">
              <input-form
                ref="form"
                :errors="errors"
                name="LoginPage"
              >
                <div class="content">
                  <h1 style="margin-top: 1%;">Welcome, {{ name }}</h1>
                  <h4>Please select the unit you would like to submit a certification for.</h4>
                  <div v-if="units != null" v-html="units" style="margin-left: 19%; margin-top: 3%; width: 1000px;"></div>
                  <!-- <div class="columns">
                    <div class="column">
                      <div class="mt-4">
                        <button class="button is-primary is-small" @click.prevent="login">Sign-in</button>
                      </div>
                    </div>
                    <div class="column">
                      <div class="mt-4">
                        <button class="button is-danger is-small" @click.prevent="signOut">Sign-out</button>
                      </div>
                    </div>
                  </div> -->
                </div>
              </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { dataObjectToXml, getPropertyValueOrDefault } from "@/utilities/functions.js";
import buildCreateAccountDataObject from "@/utilities/create-account.js";
import buildMIHProjectObject from "@/utilities/get-mih-project";

export default {
  name: "LoginPage",
  data() {
    return {
      sub: null,
      name: null,
      email: null,
      units: null,
    };
  },
  beforeCreate() {},
  beforeMount() {
    // Handle redirect if coming from Azure AD B2C
    this.createAccount();
    //this.getProjects();
  },

  methods: {
    async getProjects(){
      var cognitoSub = this.$store.getters["auth/userInfo"].sub;
        var vData = this;
       const dataObject = buildMIHProjectObject(
          cognitoSub,
          "SHARC_GET_MIH_PROJECT"
        );
        const requestObj = {
          table: "bppmzx4d2",
          data: dataObject
        };
        axios
          .post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy-Reads",
            requestObj
          ).then(response => {
            const responseObject = getPropertyValueOrDefault(["data", "record", "f"], response);
            vData.units = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "254"));
          }) 
    },
    async createAccount(){
      await this.$store.dispatch("auth/handleRedirect");
      this.sub = this.$store.getters["auth/userInfo"].sub;
      this.email = this.$store.getters["auth/userInfo"].email;
      this.name = this.$store.getters["auth/userInfo"].name;
      var vData = this;

      const dataObject = buildCreateAccountDataObject(vData);
      const xmlDataObject = dataObjectToXml(dataObject);
      const requestObject = {
        table: "bu7xdecfa",
        action: "API_AddRecord",
        data: xmlDataObject
      };
      await axios
        .post(
          "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
          requestObject
        )
        .then(() => {
          //this.awsFiles[i].uploading = false;
          //this.awsFiles[i].success = true;
          //vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;

        }).catch(() => {
          this.getProjects();
          //vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          // this.awsFiles[i].error = true;
          // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
        })
    }
  },
};
</script>
